import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _inheritsLoose from "../../inheritsLoose";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime-corejs2/helpers/applyDecoratedDescriptor";

var _dec, _class, _init, _class2, _temp;

import Intact from 'intact-vue';
import Tag from '../tag';
import template from './index.vdt';
import '../../styles/kpc.styl';
import './index.styl';
var Tip = (_dec = Intact.template(), (_class = (_temp = _class2 =
/*#__PURE__*/
function (_Tag) {
  _inheritsLoose(Tip, _Tag);

  function Tip() {
    return _Tag.apply(this, arguments) || this;
  }

  return Tip;
}(Tag), _defineProperty(_class2, "template", template), _defineProperty(_class2, "blocks", ['title', 'close']), _temp), (_applyDecoratedDescriptor(_class, "template", [_dec], (_init = _Object$getOwnPropertyDescriptor(_class, "template"), _init = _init ? _init.value : undefined, {
  enumerable: true,
  configurable: true,
  writable: true,
  initializer: function initializer() {
    return _init;
  }
}), _class)), _class));
export { Tip as default };
export { Tip };